var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconZeroTrust(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.35547,12.41406A27.57224,27.57224,0,0,0,17.40161,30.70312a9.72671,9.72671,0,0,0,.25318,19.22828A27.56276,27.56276,0,1,0,43.35547,12.41406Zm-32.584,27.88379a8.23926,8.23926,0,1,1,8.23926,8.23926A8.24881,8.24881,0,0,1,10.77148,40.29785Zm32.584,25.74561A26.17614,26.17614,0,0,1,19.31738,50.02161,9.73689,9.73689,0,0,0,28.72705,40.75H41.25V46h1.5V40.75h4.5V46h1.5V40.75h4.5V46h1.5V40a.7502.7502,0,0,0-.75-.75H28.69141a9.75,9.75,0,0,0-9.62574-8.6886,26.05885,26.05885,0,1,1,24.2898,35.48206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZeroTrust);
export default __webpack_public_path__ + "static/media/icon_zero_trust.4b9c1020c662129912520c0a32d15269.svg";
export { ForwardRef as ReactComponent };